import { Modal as AntdModal, ModalProps as AntdModalProps, ConfigProvider } from 'antd';
import { useTheme } from '../../theme/ThemeContext';
import useModal from 'antd/es/modal/useModal';

export type ModalProps = AntdModalProps & { 'data-test'?: string, 'data-test-id'?: string };

const Modal: React.FC<ModalProps> & { useModal: typeof useModal } = ({ ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdModal {...props} data-test={props['data-test']} data-asper-modal   data-test-id={props['data-test-id']} />
        </ConfigProvider>
    );
};

Modal.useModal = AntdModal.useModal;

export default Modal;
